<template>
    <div id="app">
        <v-app id="inspire">
            <template v-if="preloadingDone">
                <routerViewBox />

                <!-- 非登录页面加载 -->
                <template
                    v-if="
                        langloadingDone &&
                        $store.state.global.routerName !== 'login'
                    "
                >
                    <!-- 头部 -->
                    <v-header />
                    <v-backtop />
                    <v-download />
                    <v-modal />
                    <!-- 全局侧滑导航 -->
                    <transition
                        name="slide-left"
                        @after-leave="updateTagList"
                        @after-enter="updateTagList"
                    >
                        <v-sidenav v-show="triggerSideNavShow" />
                    </transition>

                    <v-contact
                        v-if="
                            globalBasicInfos &&
                            !$store.state.global.isNewBeveliver
                        "
                        :basicInfoData="globalBasicInfos"
                    />
                </template>
            </template>
            <template v-else>
                <loading />
            </template>
        </v-app>
    </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapMutations, mapGetters } from "vuex";
import { loggedIn } from "@/libs/token";
import loading from "@/components/loading/index.vue";
import routerViewBox from "@/components/router-view-box/index.vue";
import vContact from "@/components/contact/index.vue";
import { getSchema } from "@/api/configs";

export default {
    components: {
        loading,
        routerViewBox,
        vContact,
    },
    computed: {
        ...mapState("mixins", ["triggerSideNavShow"]),
        ...mapState("global", [
            "preloadingDone",
            "langloadingDone",
            "currentLang",
            "routerName",
            "isNewBeveliver",
        ]),
        ...mapState("triggerEvtents", ["getMenusData", "routerTriggerFn"]),
        ...mapGetters("global", ["globalBasicInfos"]),
    },
    watch: {
        getMenusData(newData) {
            this.get_menus_data();
        },
        routerTriggerFn(newData) {
            // 切换路由，隐藏侧边栏
            // this.$store.state.mixins.triggerSideNavShow = false;
            //  关闭图片详情弹框
            this.$store.state.vModal.openPictureModal = false;
            //  重置搜索条件
            this.updateClearSearchCondition();
            //  重置侧边导航
            this.updateResetSideNav();
            //  判断是否显示 最新过滤按钮
            this.updateIsFilterBtn(
                this.$P.schemaType == "latestUpdate" ? true : false
            );
            //  登陆后获取基础数据
            loggedIn("user-logged-in") && this.get_basic_info_data();
        },
    },
    data() {
        return {};
    },
    created() {
        //  如果已登录，请求数据
        if (loggedIn("user-logged-in")) {
            this.get_basic_info_data();
        }

        this.$P.$on("glTranslateChangeLang", (lang) => {
            this.google_translate_change_lang(lang);
        });
    },

    methods: {
        ...mapMutations("global", [
            "updateGlobalMenus",
            "updateLangloadingDone",
            "updateGlobalBasicInfo",
            "updateCurrentLang",
        ]),
        ...mapMutations("triggerEvtents", [
            "updateClearSearchCondition",
            "updateResetSideNav",
        ]),
        ...mapMutations("mixins", ["updateIsFilterBtn"]),
        async get_menus_data() {
            //  加载导航数据
            let { data } = await getSchema("menus", {
                lang: this.currentLang.lang,
            });
            this.updateGlobalMenus(data.menus);
            this.$store.state.mixins.isShowPage = true;
        },
        // 出发 tags 用到的 flickity 插件更新
        updateTagList() {
            window.flickity && window.flickity.resize();
        },

        //  获取基础数据
        async get_basic_info_data() {
            let { data } = await getSchema("basic-info");
            document.body.classList.add(data.roleName);
            this.updateGlobalBasicInfo(data);
            this.get_new_believer_language(data.roleName);
            this.get_goolge_translate(data.roleName);
        },
        // 获取语言包
        async get_new_believer_language(roleName) {
            //  预设当前语言 (目前只支持两种语言)
            let lang = roleName.includes("new-believer") ? "en_US" : "zh_TW";
            let { data } = await getSchema("translations?lang=" + lang);
            Vue.prototype.$TL = data;
            this.get_menus_data();
            this.updateLangloadingDone();
        },
        //  如果是新人账号，加载Google 翻译
        get_goolge_translate(user) {
            if (!user.includes("new-believer")) return;
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src =
                "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
            script.text = googleTranslateElementInit;
            document.body.appendChild(script);

            script.onload = function (e) {
                setTimeout(() => googleTranslateElementInit(), 500);
            };

            let _salfe = this;

            function googleTranslateElementInit() {
                new google.translate.TranslateElement(
                    {
                        pageLanguage: "zh-CN",
                        layout: google.translate.TranslateElement.InlineLayout
                            .horizontal,
                        autoDisplay: false,
                    },
                    "google_translate_element"
                );

                _salfe.$P.$emit("resizeTagFlickity");
                setTimeout(
                    () =>
                        _salfe.google_translate_change_lang(
                            _salfe.currentLang.lang
                        ),
                    800
                );
            }
        },
        //  新人账号调取Google 翻译
        google_translate_change_lang(lang) {
            if (!this.isNewBeveliver) return;
            $("#google_translate_element option").map((i, val) => {
                let gCode = val.getAttribute("value");
                if (lang.includes(gCode)) {
                    gCode && $("select.goog-te-combo").val(gCode);
                } else if (lang == "zh_TW") {
                    $("select.goog-te-combo").val("zh-CN");
                } else if (lang == "he_IL") {
                    $("select.goog-te-combo").val("iw");
                } else if (lang == "hm_HM") {
                    $("select.goog-te-combo").val("hmn");
                }
            });

            let fireEvent = (el, e) => {
                var evt = document.createEvent("HTMLEvents");
                evt.initEvent(e, true, true);

                this.$P.$emit("resizeTagFlickity");
                return !el.dispatchEvent(evt);
            };
            fireEvent($("select.goog-te-combo").get(0), "change");
        },
    },
};
</script>
<style lang="scss">
body:not([data-slug="login"]) {
    #app {
        padding-top: 64px;
    }
}
.v-application--wrap {
    min-height: 86vh;
}
</style>
